import React from 'react';
// import { Icon } from '@nt/dds-react';
import { Link, useLocation } from 'react-router-dom';
import './Navbar.css';

interface Props {}

const Navbar: React.FC<Props> = () => {
  const location = useLocation().pathname.split('/');
  const currentRoute = location[location.length - 1];

  return (
    <div className="nav-bar-menu">
      <ul className="nav-bar-ul">
        <li className={currentRoute === '' ? 'nav-item-active' : ''}>
          <Link to="/">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              aria-label="View Dashboard"
              width="28"
              height="28"
              viewBox="0 0 24 25"
              fill="none"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M13 3.78516V9.78516H21V3.78516H13ZM13 21.7852H21V11.7852H13V21.7852ZM3 21.7852H11V15.7852H3V21.7852ZM3 13.7852H11V3.78516H3V13.7852Z"
                fill="#6b6e6f"
              />
            </svg>
          </Link>
        </li>
        {/* <li>
          <Icon ariaHidden name="history" aria-label="History" className="nav-bar-ul-icon" type="info" />
        </li>
        <li>
          <Icon ariaHidden name="drafts" aria-label="Message Center" className="nav-bar-ul-icon" type="info" />
        </li> */}
      </ul>
    </div>
  );
};

Navbar.displayName = 'Navbar';
export default Navbar;
